var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scheduled-loads", {
    attrs: {
      loads: _vm.deliveredLoads,
      company: _vm.company,
      status: _vm.loadStatus.DELIVERED
    },
    on: {
      refresh: function($event) {
        return _vm.$emit("refresh")
      },
      updateLoad: function($event) {
        return _vm.$emit("updateLoad", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-264aa5a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264aa5a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Receiving/Delivered.vue
// module id = null
// module chunks = 